export default __webpack_public_path__ + "static/5-361429315dfddab3c838ef0d95f721e9.jpg";